exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-max[data-v-25b3853e]{max-height:calc(100vh - 100px);overflow:scroll}.page-max[data-v-25b3853e]::-webkit-scrollbar{width:0px;height:0px;background:transparent}.page-max[data-v-25b3853e]::-webkit-scrollbar-thumb{background:transparent;border-radius:4px}.page-max[data-v-25b3853e]:hover::-webkit-scrollbar-thumb{background:rgba(135,135,135,.4)}.page-max[data-v-25b3853e]:hover::-webkit-scrollbar-track{background:rgba(135,135,135,.1)}", ""]);

// exports
